<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            客服列表
        </div>
        <div style="padding: 20px;">
            <div>
                <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>
                <div style="clear: both;"></div>
            </div>
            <div style="height: 10px;"></div>
            <div>
                <template>
                    <el-table v-loading="tableLoading" :data="tableData" :height="th" border style="width: 100%;" :header-cell-style="tabHeader">
                        <el-table-column prop="name" label="名称"></el-table-column>
                        <el-table-column prop="phone" label="联系电话"></el-table-column>
                        <el-table-column prop="callingPhone" label="主叫800号码"></el-table-column>
                        <el-table-column prop="governmentName" label="政府"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="text" size="medium"
                                           @click="handleEdit(scope.$index, scope.row)">编辑
                                </el-button>
                                <el-button type="text" size="medium"
                                           @click="handleEditStaff(scope.$index, scope.row)">关联后台账号</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
                        </div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:governmentList="governmentList" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-bind:governmentList="governmentList" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
        <EditStaff ref="myEditStaff" v-show="showModalEditStaff" v-on:closeEditStaff="closeEditStaff" v-on:getList="getList"></EditStaff>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import EditStaff from "./EditStaff";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data() {
            return {
                tableLoading: false,
                showModalEditStaff: false,
                showModalAdd: false,
                showModalEdit: false,
                name: '',
                serviceStatus: 0,
                tableData: null,
                totalItems: 0,
                pageSize: 20,
                currentPage: 1,
                serviceStatusValue: ['所有状态', '正常服务', '停止服务'],
                th: 0,
                governmentList:[]
            }
        },
        components: {
            Add, Edit, EditStaff
        },
        created() {
            this.getList();
            this.getGovernmentList()
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight': function (val) {
                this.th = val;
            },
        },
        methods: {
            getGovernmentList(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'Government/List',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((response)=> {
                    if(response.data.error == 0){
                        this.governmentList = response.data.data;
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            // 修改table header的背景色
            tabHeader() {
                return 'color:#333;fonts-weight:bold;'
            },

            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd: function () {
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },

            AddBinding: function(row){
                this.showModalBinding =!this.showModalBinding;
                this.$refs.myBinding.init(row);
            },
            handleEditStaff(index, row) {
                this.$refs.myEditStaff.init(row);
                this.showModalEditStaff = !this.showModalEditStaff;
            },
            closeAdd: function () {
                this.showModalAdd = !this.showModalAdd;
            },
            closeEditStaff: function () {
                this.showModalEditStaff = !this.showModalEditStaff;
            },
            toggleModalEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },
            closeBinding: function () {
                this.showModalBinding = !this.showModalBinding;
            },

            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.getList();
            },

            genders(row) {
                if (row.gender == 0) {
                    return "女";
                }
                if (row.gender == 1) {
                    return "男";
                }
            },
            serviceStatu(row) {
                if (row.serviceStatus == 0) {
                    return "正常服务";
                }
                if (row.serviceStatus == 1) {
                    return "停止服务";
                }
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1
                var _this=this
                this.tableLoading=true
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl + "Seats/Page",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex: this.currentPage,
                        pageSize: this.pageSize,
                    }
                }).then((response) => {
                    _this.tableLoading=false
                    if (response.data.error == 0) {
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }
                }).catch(function (error) {
                    _this.tableLoading=false
                    console.log(error);
                });
            },
        }
    }
</script>

<style scoped>

</style>
